export{Flipper,spring}from"react-flip-toolkit/lib/FlipToolkit";
//# sourceMappingURL=index.es.js.map
